/* eslint-disable @typescript-eslint/no-explicit-any */
export var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};